import { PagenatedResponse, SearchPagenateQuery } from '@models/common';
import { apiClient } from '.';
import { CreateProgramInvoiceDto, ProgramInvoice } from '@models/program-invoice';

const BASE_URL = '/admin/v1/program-invoices';

export async function searchProgramInvoices(query: SearchPagenateQuery) {
  const { data } = await apiClient.get<PagenatedResponse<ProgramInvoice>>(BASE_URL, {
    params: query,
  });
  return data;
}

export async function getProgramInvoice(id: string) {
  const { data } = await apiClient.get<ProgramInvoice>(`${BASE_URL}/${id}`);
  return data;
}

export async function createProgramInvoice(createDto: CreateProgramInvoiceDto) {
  const { data } = await apiClient.post<ProgramInvoice>(BASE_URL, createDto);
  return data;
}

export async function updateProgramInvoice(id: string, updateDto: Partial<CreateProgramInvoiceDto>) {
  const { data } = await apiClient.put<ProgramInvoice>(`${BASE_URL}/${id}`, updateDto);
  return data;
}

export async function deleteProgramInvoice(id: string) {
  await apiClient.delete(`${BASE_URL}/${id}`);
}
